import { AppGlobals } from '../AppGlobals';
import { IApp03PortfolioUser } from '../types';
import { EntityService } from './EntityService';

export class App03PortfolioUserService extends EntityService<IApp03PortfolioUser> {
    constructor() {
        super(`/App03PortfolioUsers`);
    }

    // public readAllForList(portfolioID?: number): Promise<IApp03PortfolioUser[]> {
    //     return this.readAll(
    //         `?$orderby=User/Title&$expand=User,App03Workflow&$filter=User/CustomerID eq ${AppGlobals.CustomerID}`
    //         + (portfolioID ? ` and App03PortfolioID eq ${portfolioID}` : '')
    //     );
    // }

    // public checkForDuplicates = (userId: number, workflowID: number): Promise<IApp03PortfolioUser[]> => {
    //     return this.readAll(`?$filter=UserID eq ${userId} and App03WorkflowID eq ${workflowID}&$select=ID`);
    // }

    // public readWorkflowUsers(workflowID: number): Promise<IApp03PortfolioUser[]> {
    //     return this.readAll(
    //         `?$orderby=User/Title&$expand=User&$filter=User/CustomerID eq ${AppGlobals.CustomerID}`
    //         + (workflowID ? ` and App03WorkflowID eq ${workflowID}` : '')
    //     );
    // }

}